import { HexColorPicker } from 'react-colorful'
import { HexColorInput } from './HexColorInput'
import {
  amber,
  blue,
  crimson,
  cyan,
  grass,
  green,
  indigo,
  iris,
  jade,
  orange,
  pink,
  plum,
  purple,
  red,
  ruby,
  teal,
  tomato,
  violet,
} from '@radix-ui/colors'

const baseColors = {
  tomato,
  red,
  ruby,
  crimson,
  pink,
  plum,
  purple,
  violet,
  iris,
  indigo,
  blue,
  cyan,
  teal,
  jade,
  green,
  grass,
  orange,
  amber,
} as const

const pickerColors = Object.values(baseColors).map((palette) => Object.values(palette)[8] ?? '')

export const HexColorPopover = ({
  color,
  setColor,
}: {
  color: string | undefined
  setColor: (color: string) => void
}) => {
  return (
    <div className="flex flex-col gap-2">
      <HexColorPicker color={color} onChange={setColor} />
      <div className="flex flex-wrap gap-1.5">
        {pickerColors.map((presetColor) => (
          <button
            type="button"
            key={presetColor}
            className="size-7 rounded"
            style={{ background: presetColor }}
            onClick={() => setColor(presetColor)}
          />
        ))}
      </div>
      <HexColorInput value={color} onChange={setColor} />
    </div>
  )
}
